// axios
import axios from 'axios'

const EXPIRED_MESSAGE = 'EXPIRED_MESSAGE';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Authorization: 'Bearer {token}',
  },
});

export const fisgApi = axios.create({
  baseURL: process.env.VUE_APP_FISG_API_URL,
  headers: {
    Authorization: 'Bearer {token}',
  },
});

//
// api.CancelToken = axios.CancelToken;
// api.isCancel = axios.isCancel;
//
// // Set the AUTH token for any request
// api.interceptors.request.use((config) => {
//   const token = store.getters.authToken;
//   config.headers.Authorization = token ? `Bearer ${token}` : '';
//
//   return config;
// });
//
// // Log out the user if they find unauthorized
// api.interceptors.response.use(
//   response => Promise.resolve(response),
//   (error) => {
//     // We are checking here to see if they are expired, and to log them out if so
//     if (error.message) {
//       if (error.message === EXPIRED_MESSAGE) {
//         store.dispatch('logout', { expired: true });
//         return;
//       }
//     }
//
//     if (error.response) {
//       if (error.response.status === 401) {
//         store.dispatch('logout');
//         return;
//       }
//
//       if (error.response.status === 500) {
//         Vue.rollbar.error(error);
//       }
//
//       const errorBag = error.response.data.error;
//       // This means we have thrown an exception that we want to display an error to the user
//       if (errorBag) {
//         // Show any validation errors automatically
//         let errors = errorBag.message;
//
//         // If we have specific errors, show these instead
//         if (errorBag.errors) {
//           errors = Object.values(errorBag.errors);
//           errors = errors[0][0];
//         }
//
//         if (errors) {
//           // Vue.notify({
//           //   duration: 7000,
//           //   title: 'Error',
//           //   text: errors,
//           //   type: 'error',
//           // });
//         }
//       }
//     }
//
//     return Promise.reject(error);
//   },
// );

export default api;
